export default __webpack_public_path__ + "static/hero-bg-desktopSmall-8d35c89d57c724dda065e244bbd5d4b6.png";